module.exports = __webpack_public_path__ + "static/logo-b864f4b9ab258644ac317b9e21df8b69.png";